import React from 'react';
import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { goToSubstep } from 'registration/creative/ducks';
import Substep2_3 from 'registration/creative/components/substep2_3';

const mapStateToProps = ({
  user,
  creativeRegistration: {
    workSamples, avatar, registrationSubmittedAt, registrationReopenedAt, idValidated
  }
}) => ({
  user,
  workSamples,
  avatar,
  registrationSubmittedAt,
  registrationReopenedAt,
  idValidated
})

export default connect(mapStateToProps, {
  nextSubstep: partial(goToSubstep, 'review')
})(Substep2_3);



// WEBPACK FOOTER //
// ./registration/creative/containers/substep2_3.jsx